<template>
  <div style="background: red">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "custom-ele"
};
</script>

<style scoped></style>
